// extracted by mini-css-extract-plugin
export default {"video_container":"content_video_container__T3vnp","header":"content_header__s1Fl5"};